import { Input, Modal, Button, Select } from 'antd'
import { useDispatch } from 'react-redux'
import React, { useState } from 'react'
import { editTemplateFieldAdd } from 'states/modules/editTemplate'
import { fieldStructure } from '../../form/fieldStructure'
import { bool, func, number, object } from 'prop-types'
import { ButtonWrapper, InputWrapper } from '../../form/widgets/base/styles'

const AddVariableModal = ({ open, onCancel, widgetIndexes, editor }) => {
	const dispatch = useDispatch()

	const [values, setValues] = useState({
		name: '',
		question: '',
		field: '',
	})

	const handleChange = (field, value) => {
		if (field === 'name') {
			const last = value.length - 1

			let updateValue = value
			if (value.charAt(last) === ' ') {
				updateValue = value.slice(0, last) + '_'
			}

			setValues({ ...values, [field]: updateValue })
		} else {
			setValues({ ...values, [field]: value })
		}
	}
	//todo: Can't we get this from the original list of widgets? Duplicating this list makes it harder to mantain.
	const fieldTypes = [
		{ value: 'text', label: 'Texto' },
		{ value: 'text_area_ckeditor', label: 'Parágrafo Composto' },
		{ value: 'number', label: 'Número' },
		{ value: 'cpf', label: 'CPF' },
		{ value: 'cnpj', label: 'CNPJ' },
		{ value: 'email', label: 'Email' },
		{ value: 'date', label: 'Data' },
		{ value: 'time', label: 'Hora' },
		{ value: 'currency', label: 'Moeda' },
		{ value: 'bank', label: 'Banco' },
		{ value: 'cnae', label: 'CNAE' },
		{ value: 'dropdown', label: 'Dropdown' },
		{ value: 'radio', label: 'Rádio' },
		{ value: 'checkbox', label: 'Checkbox' },
		{ value: 'variable_image', label: 'Upload de imagem' },
		{ value: 'api', label: 'API Simples' },
		{ value: 'database', label: 'API com search' },
		{ value: 'text_database', label: 'Banco de Textos' },
		{ value: 'internal_database', label: 'Banco de Dados' },
		{ value: 'person', label: 'Pessoa' },
		{ value: 'address', label: 'Endereço' },
		{ value: 'structured_list', label: 'Lista Estruturada' },
		{ value: 'separator', label: 'Separador' },
		{ value: 'description', label: 'Descrição' },
		{ value: 'attachment', label: 'Anexo' },
	]

	const onSubmitValues = () => {
		const { field, question, name } = values
		const newField = fieldStructure(field, question, name)
		dispatch(editTemplateFieldAdd({ newField, pageIndex: widgetIndexes }))

		if (editor !== null) {
			editor.model.change((writer) => {
				writer.insertText(
					`{{ ${name} }}`,
					editor.model.document.selection.getFirstPosition()
				)
			})
		}

		setValues({
			name: '',
			question: '',
			field: '',
		})
		onCancel()
	}

	return (
		<Modal
			title="Nova variável"
			centered
			visible={open}
			footer={null}
			onCancel={onCancel}
			width={450}
			getContainer={false}>
			<InputWrapper>
				<label>Nome:</label>
				<Input
					value={values.name}
					onChange={(e) => handleChange('name', e.target.value.toUpperCase())}
				/>
			</InputWrapper>
			<InputWrapper>
				<label>Pergunta:</label>
				<Input
					value={values.question}
					onChange={(e) => handleChange('question', e.target.value)}
				/>
			</InputWrapper>
			<InputWrapper $marginBottom="24px">
				<label>Tipo de variável:</label>
				<Select
					showSearch
					value={values.field}
					onChange={(e) => handleChange('field', e)}
					options={fieldTypes}
					filterOption={(input, option) =>
						(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
					}
				/>
			</InputWrapper>
			<ButtonWrapper>
				<Button onClick={onSubmitValues}>Criar</Button>
			</ButtonWrapper>
		</Modal>
	)
}

AddVariableModal.propTypes = {
	open: bool,
	onCancel: func,
	widgetIndexes: number,
	editor: object,
}

export default AddVariableModal
